type AddressParts = {
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  zipcode?: string | null;
  country?: string | null;
};

export function getAddressString(address: AddressParts) {
  let addressString = [
    address.line1,
    address.line2,
    address.city,
    address.stateCode,
  ]
    .filter((part) => part)
    .join(', ');

  if (address.zipcode) {
    addressString += ` ${address.zipcode}`;
  }

  if (address.country !== 'US') {
    addressString += `, ${address.country}`;
  }

  return addressString;
}
